var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M189.156,0C84.858,0,0.001,84.858,0.001,189.155c0,104.298,84.857,189.155,189.155,189.155\n\t\t\tc104.304,0,189.154-84.857,189.154-189.155C378.31,84.858,293.46,0,189.156,0z M189.156,347.144\n\t\t\tc-87.117,0-157.988-70.87-157.988-157.988c0-87.115,70.871-157.988,157.988-157.988c87.117,0,157.986,70.873,157.986,157.988\n\t\t\tC347.142,276.273,276.272,347.144,189.156,347.144z","key":0}),React.createElement("path",{"d":"M204.739,182.963V75.841c0-8.606-6.977-15.584-15.583-15.584c-8.605,0-15.582,6.978-15.582,15.584v113.314\n\t\t\tc0,4.839,2.25,9.101,5.703,11.962c0.146,0.176,0.245,0.373,0.397,0.546l58.438,66.354c3.082,3.49,7.381,5.279,11.701,5.279\n\t\t\tc3.652,0,7.33-1.276,10.289-3.888c6.461-5.692,7.084-15.537,1.398-21.998L204.739,182.963z","key":1})]);
}

Clock.defaultProps = {"viewBox":"0 0 378.311 378.311"};

module.exports = Clock;

Clock.default = Clock;
